import { CommonModule, DatePipe, Location } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { PatientService } from '../patient/patient.service';
import { IPatientInfo } from '../patient/ipatient-info';
import { GenderList } from 'src/app/common/types/common';
import { environment } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { IpdFormComponent } from './ipd-form/ipd-form.component';
import { OPDService } from '../opd/opd.service';
import { Iopd } from '../opd/opddetails/iopddetails';
import { UserService } from '../user/user.service';
import { IUsers } from '../user/iusers';
import { catchError, finalize, forkJoin, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { MedicalReportType } from 'src/app/common/enums/medical-report-type';
import { IpdService } from './ipd.service';
import { Iipd, IoperationSummary } from './Iipd.type';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { HospitalStateService } from 'src/app/services/hospitalstate.service';
import { TimeFormatPipe } from 'src/app/pipe/time.pipe';
import { FallbackImageDirective } from 'src/app/common/directive/fallback-image.directive';
import { MatDialog } from '@angular/material/dialog';
import { IpdOperationSummaryComponent } from './ipd-operation-summary/ipd-operation-summary.component';
import { AddBillChargeComponent } from '../dialogs/bill/bill.component';
import { BillType } from 'src/app/common/enums/bill-type';
import { IPDBillData } from '../dialogs/bill/ipd-bill-data.interface';
import { BillDialogData } from '../dialogs/bill/bill-dialog-data.interface';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { IpdDischargeComponent } from './ipd-discharge/ipd-discharge.component';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { PrescriptionComponent } from '../opd/prescription/prescription.component';
import { MedicalCertificateComponent } from './medical-certificate/medical-certificate.component';
import { PatientViewComponent } from '../patient/patient-view/patient-view.component';
import { PrintSettingService } from '../settings/hospital-setting/print-setting/print-setting.service';
import { DefaultValuePipe } from 'src/app/pipe/default-value.pipe';
import { MedicalRecordDetailComponent } from '../patient/patient-view/medical-record/medical-record-detail/medical-record-detail.component';
import { MedicalRecordComponent } from '../patient/patient-view/medical-record/medical-record.component';
import { AddressUtils } from 'src/app/common/utils/address.utils';
import { PatientNameUtils } from 'src/app/common/utils/patient-name.utils';
import { CommonDatePipe } from 'src/app/pipe/common-date.pipe';
import { DayToDayComponent } from './day-to-day/day-to-day.component';
import { PatientDailyReportService } from 'src/app/shared/patient-daily-report/patient-daily-report.service';
import { IPatientDailyReport } from 'src/app/shared/patient-daily-report/patient-daily-report.types';
import { PatientDailyReportComponent } from 'src/app/shared/patient-daily-report/patient-daily-report-detail/patient-daily-report.component';

@Component({
  selector: 'app-ipd',
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    TranslateModule,
    TimeFormatPipe,
    CommonDatePipe,
    FallbackImageDirective,
    LoaderComponent,
    IpdDischargeComponent,
    MedicalRecordComponent
  ],
  providers: [
    DatePipe,
    CommonDatePipe,
    TimeFormatPipe,
    DefaultValuePipe
  ],
  templateUrl: './ipd.component.html',
  styleUrl: './ipd.component.scss'
})
export class IpdComponent implements OnInit, OnDestroy {

  patientinfo: IPatientInfo;
  staticimagepath: string = environment.imagePath;
  defaultAvatarPath = 'assets/images/profile/user-1.jpg';
  OpdData: Iopd;
  doctorDetails: IUsers;
  ipdData: Iipd;
  operationSummary: IoperationSummary | null = null;
  dailyReports: IPatientDailyReport[] = [];
  @ViewChild(IpdFormComponent) ipdFormComponent!: IpdFormComponent;
  @ViewChild(MedicalRecordComponent) medicalRecordComponent!: MedicalRecordComponent;
  displayedColumns: string[] = [
    'days',
    'date',
    'time',
    'diagnosis',
    'treatment',
  ];
  dataSource = new MatTableDataSource<any>();
  showPatientInfo: boolean = false;
  medicalRecordCount: number = 0;
  private destroy$ = new Subject<void>();
  ipdDetails: Iipd;
  @ViewChild('reportPrintComponent') reportPrintComponent!: IpdDischargeComponent;

  constructor(
    private route: ActivatedRoute,
    private patientService: PatientService,
    private location: Location,
    private opdService: OPDService,
    private userService: UserService,
    private ipdService: IpdService,
    private http: HttpClient,
    private hospitalState: HospitalStateService,
    private datePipe: DatePipe,
    private commonDatePipe: CommonDatePipe,
    private timeFormatPipe: TimeFormatPipe,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private router: Router,
    private printSettingService: PrintSettingService,
    private defaultValuePipe: DefaultValuePipe,
    private dailyReportService: PatientDailyReportService
  ) { }

  ngOnInit(): void {
    // Load patient
    this.loadPatient();
    this.loadIpdData();
  }

  goBack() {
    this.location.back();
  }

  getGenderName(value?: string): string {
    const gender = GenderList.find(g => g.value === value);
    return gender ? gender.name : '';
  }

  get profileImagePathSrc(): string {
    if (this.patientinfo?.profileImagePath) {
      return this.staticimagepath + this.patientinfo.profileImagePath;
    }
    return this.defaultAvatarPath;
  }

  async printAdmissionPaper() {
    if (!this.ipdData || !this.OpdData) {
      return;
    }
    // Open dialog with IPD form in edit mode
    const dialogRef = this.dialog.open(IpdFormComponent, {
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        OPDDetails: this.OpdData,
        existingIpdData: this.ipdData,
        readOnly: this.hasDischargeDate(),
        onPrint: () => {
          // Print current form data (will be updated data if user updated)
          this.printAdmissionPaperWithCurrentData();
        }
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.updated) {
        // Reload IPD data after update
        this.loadIpdData();
      }
    });
  }

  async printAdmissionPaperWithCurrentData() {
    try {
      this.loaderService.show();
      const printContent = await this.createPrintContent();
      this.openPrintWindow(printContent);
    } catch (error) {
      console.error('Error printing admission paper:', error);
      this.toastr.error('Error loading data for printing');
    } finally {
      this.loaderService.hide();
    }
  }

  private async createPrintContent(): Promise<string> {
    try {
      let template =
        (await this.http
          .get('assets/print-template.html', { responseType: 'text' })
          .toPromise()) || '';

      const hospital = this.hospitalState.getHospital();
      const doctorId = this.OpdData.doctorId;

      const [doctor, settings] = await Promise.all([
        this.userService.getUserByID(doctorId).toPromise(),
        this.printSettingService.getPrintSettingPromise(hospital.id)
      ]);

      const doctorName = `${doctor?.result?.firstName ?? ''} ${doctor?.result?.lastName ?? ''}`.trim();
      const hospitalDetails = hospital || {};
      const patientImageSrc = this.patientinfo.profileImagePath
        ? this.staticimagepath + this.patientinfo.profileImagePath
        : ``;

      const patientImageHtml = `
          <div id="patient-image-box" style="width:90px;">
            <img src="${patientImageSrc}"
                style="width:90px; height:100px; border:1px solid #000;"
                onerror="this.parentElement.style.display='none'" />
          </div>
        `;
      const patientAddress = AddressUtils.formatPatientAddress(this.patientinfo,);
      const patientAddressHtml = patientAddress
        ? `<strong>Address:</strong> ${patientAddress}<br/>`
        : '';
      const hasPrintValue = (value: unknown): boolean => {
        const text = value?.toString().trim();
        return !!text && text !== '-';
      };
      const printLine = (label: string, value: unknown): string =>
        hasPrintValue(value) ? `<strong>${label}:</strong> ${value}<br/>` : '';
      const printCell = (label: string, value: unknown): string =>
        hasPrintValue(value)
          ? `<td style="border:1px solid #000; padding:6px;"><strong>${label}:</strong> ${value}</td>`
          : '<td style="border:1px solid #000; padding:6px;"></td>';
      const printRow = (cells: string[], values: unknown[]): string =>
        values.some((value) => hasPrintValue(value))
          ? `<tr>${cells.join('')}</tr>`
          : '';
      const patientPhoneHtml = printLine(
        'Ph',
        this.patientinfo.contactInfo?.[0]?.contact,
      );
      const opdDate = this.datePipe.transform(
        this.OpdData.opdDate,
        'dd-MM-yyyy',
      );
      const ipdDate = this.datePipe.transform(
        this.ipdData.ipdDate,
        'dd-MM-yyyy',
      );
      const admissionTableHtml = [
        printRow(
          [
            printCell('O.P.D No', this.OpdData.opdNumber),
            printCell('O.P.D Date', opdDate),
            printCell('Bed No', this.ipdData.bedNo),
          ],
          [this.OpdData.opdNumber, opdDate, this.ipdData.bedNo],
        ),
        printRow(
          [
            printCell('I.P.D No', this.ipdData.ipdNumber),
            printCell('I.P.D Date', ipdDate),
            printCell('Ward', this.ipdData.wardName),
          ],
          [this.ipdData.ipdNumber, ipdDate, this.ipdData.wardName],
        ),
        printRow(
          [
            printCell('Mediclaim', this.ipdData?.mediclaimName),
            printCell('Policy No', this.ipdData?.policyNumber),
            '<td style="border:1px solid #000; padding:6px;"></td>',
          ],
          [this.ipdData?.mediclaimName, this.ipdData?.policyNumber],
        ),
      ].join('');
      const relativeNameAddressHtml = hasPrintValue(this.ipdData.nameAndAddress)
        ? `<strong>Name & Address of relative / friend attending patient:</strong><br/>${this.ipdData.nameAndAddress}<br/>`
        : '';
      const relativeContactHtml = printLine('Tel No', this.ipdData.contact);
      const relativeDetailsHtml =
        relativeNameAddressHtml || relativeContactHtml
          ? `<div style="margin-top:15px; font-size:13px;">${relativeNameAddressHtml}${relativeContactHtml}</div>`
          : '';
      const admittedOnHtml = hasPrintValue(ipdDate)
        ? `<strong>Admitted On:</strong> ${ipdDate}`
        : '';
      const admissionTime = this.timeFormatPipe.transform(this.ipdData.ipdTime);
      const admittedAtHtml = hasPrintValue(admissionTime)
        ? `<strong>At:</strong>${admissionTime}`
        : '';
      const admittedDateTimeHtml =
        admittedOnHtml || admittedAtHtml
          ? `<div style="margin-top:15px; font-size:13px;">${admittedOnHtml}${admittedOnHtml && admittedAtHtml ? '&nbsp;&nbsp;' : ''}${admittedAtHtml}</div>`
          : '';
      const diagnosisHtml = hasPrintValue(this.ipdData.provisionalDiagnosis)
        ? `<div style="margin-top:15px; font-size:13px;"><strong>Diagnosis:</strong><br/>${this.ipdData.provisionalDiagnosis}</div>`
        : '';

      const admissionHtml = `
      <h2 style="text-align:center; margin:10px 0; text-decoration:underline;">
        ADMISSION PAPER
      </h2>

      <div style="display:flex; gap:12px; border:1px solid #000; padding:8px; margin:10px 0;">
        ${patientImageHtml}
        <div style="flex:1; font-size:13px;">
          <strong>Patient Name:</strong>
          ${PatientNameUtils.formatFullName(this.patientinfo)}<br/>
          ${patientAddressHtml}
          ${patientPhoneHtml}
        </div>
      </div>

      <table style="width:100%; border-collapse:collapse; margin-top:18px; font-size:13px;">
        ${admissionTableHtml}
      </table>


      ${admittedDateTimeHtml}
        &nbsp;&nbsp;
      </div>

      ${diagnosisHtml}
        <div>
          <strong>Signature:</strong><br/>
          Patient / Guardian / Relation
        </div>
      </div>
    `;

      const fullImagePath = hospitalDetails?.logo ? `${this.staticimagepath}${hospitalDetails.logo}` : null;
      const defaultLogo = `${window.location.origin}/assets/images/svgs/hospital.png`;

      const replacements: Record<string, string> = {
        reportTitle: `Admission Paper of ${PatientNameUtils.formatFullName(this.patientinfo)}`,
        hospitalName: this.defaultValuePipe.transform(hospitalDetails.name, ''),
        hospitalAddress: this.defaultValuePipe.transform(hospitalDetails.address, ''),
        phone: this.defaultValuePipe.transform(hospitalDetails.phone, ''),
        reportSections: admissionHtml,
        doctorName: doctorName,
        qualification: this.defaultValuePipe.transform(doctor?.result?.degree, '') ,
        doctorRegistrationNo: doctor?.result?.registrationNumber 
          ? `Reg No. ${this.defaultValuePipe.transform(doctor?.result?.registrationNumber, '')}` 
          : '',
        doctorPhone: doctor?.result?.phoneNumber 
          ? `M. ${this.defaultValuePipe.transform(doctor?.result?.phoneNumber, '')}` 
          : '',
        logo: `<img src="${fullImagePath || defaultLogo}" class="logo" onerror="this.onerror=null;this.src='${defaultLogo}'"/>`,
        patientName: PatientNameUtils.formatFullName(this.patientinfo),
        patientAge: `${this.getGenderName(this.patientinfo.gender)} / ${this.patientinfo.age}`,
        opdNumber: this.OpdData.opdNumber || '',
        opdDate: this.commonDatePipe.transform(this.OpdData.opdDate)
      };

      let filledTemplate = template;
      for (const key in replacements) {
        const value = replacements[key] ?? '';
        const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
        filledTemplate = filledTemplate.replace(regex, value);
      }

      // Apply settings
      if (settings) {
        const logoPos = settings.logoPosition === 'center' ? 'column' : (settings.logoPosition === 'left' ? 'row' : 'row-reverse');
        const headerClass = settings.logoPosition === 'center' ? 'center' : '';
        const headerAlignment = settings.addressAlignment || 'left';

        const styles = `
            :root {
                --logo-size: ${settings.logoSize || '60px'};
                --logo-position: ${logoPos};
                --header-alignment: ${headerAlignment};
                --hospital-name-size: ${settings.hospitalNameSize || 20}px;
                --address-font-size: ${settings.addressFontSize || 13}px;
                --footer-display: ${settings.showFooter ? 'block' : 'none'};
                --doctor-signature-top-display: ${settings.showFooter && settings.doctorNamePosition === 'top' ? 'block' : 'none'};
                --doctor-signature-bottom-display: ${settings.showFooter && settings.doctorNamePosition === 'footer' ? 'block' : 'none'};
            }
        `;
        filledTemplate = filledTemplate.replace('</head>', `<style>${styles}</style></head>`).replace('{{headerClass}}', headerClass);
      } else {
        filledTemplate = filledTemplate.replace('{{headerClass}}', '');
      }

      return filledTemplate;
    } catch (error) {
      console.error('Error creating admission paper print content:', error);
      throw error;
    }
  }

  private openPrintWindow(content: string): void {

    let iframe = document.getElementById('print-frame') as HTMLIFrameElement;

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'print-frame';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }

    const doc = iframe.contentWindow?.document;

    if (!doc) {
      return;
    }

    doc.open();
    doc.write(content);
    doc.close();

    setTimeout(() => {
      iframe.contentWindow?.print();
    }, 300);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadIpdData(): void {
    const ipdId = Number(this.route.snapshot.paramMap.get('ipdId'));
    if (!ipdId) return;

    this.loaderService.show();
    this.ipdService.getIPDById(ipdId).pipe(
      takeUntil(this.destroy$),
      tap(ipdRes => {
        this.ipdData = ipdRes.result;
      }),
      switchMap(ipdRes => {
        const opdId = ipdRes.result?.opdId;
        const doctorId = ipdRes.result?.doctorId;
        const currentIpdId = ipdRes.result?.id;
        const patientId = Number(this.route.snapshot.paramMap.get('patientId'));

        return forkJoin({
          opd: opdId ? this.opdService.getOPDById(opdId) : of(null),
          doctor: doctorId ? this.userService.getUserByID(doctorId) : of(null),
          operationSummary: currentIpdId ? this.ipdService.getOperationSummaryByIpdId(currentIpdId).pipe(
            catchError(() => of({ result: null, isSuccess: false }))
          ) : of({ result: null, isSuccess: false }),
          dailyReports: currentIpdId && patientId ? this.dailyReportService.list({
            patientId,
            opdId: opdId ?? null,
            ipdId: currentIpdId
          }).pipe(catchError(() => of({ result: [], isSuccess: false }))) : of({ result: [], isSuccess: false })
        });
      }),
      finalize(() => {
        this.loaderService.hide();
      })
    ).subscribe({
      next: ({ opd, doctor, operationSummary, dailyReports }) => {
        if (opd) {
          this.OpdData = opd.result;
        }
        if (doctor) {
          this.doctorDetails = doctor.result;
        }
        if (operationSummary?.result) {
          this.operationSummary = operationSummary.result;
        } else {
          this.operationSummary = null;
        }
        this.dailyReports = dailyReports?.result ?? [];
      },
      error: err => {
        console.error(err);
      }
    });
  }

  private loadPatient(): void {
    const patientId = Number(this.route.snapshot.paramMap.get('patientId'));
    if (!patientId) {
      return;
    }

    this.patientService.getPatientByID(patientId)
      .pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          console.error('Error loading patient:', err);
          return of({ result: null });
        })
      )
      .subscribe(res => {
        if (res?.result) {
          this.patientinfo = res.result;
        }
      });
  }

  openOperationSummary() {
    if (!this.ipdData?.id) {
      return;
    }

    // Use already loaded operation summary data
    const isUpdateMode = this.operationSummary !== null;
    const existingOperationSummary = this.operationSummary || undefined;

    this.dialog.open(IpdOperationSummaryComponent, {
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        patientDetails: this.patientinfo,
        opdDetails: this.OpdData,
        ipdId: this.ipdData.id,
        isUpdateMode: isUpdateMode,
        existingOperationSummary: existingOperationSummary,
        readOnly: this.hasDischargeDate()
      }
    }).afterClosed().subscribe((result) => {
      if (result) {
        // Reload operation summary after successful save/update
        this.loadOperationSummary();
      }
    });
  }

  private loadOperationSummary(): void {
    if (!this.ipdData?.id) return;

    this.ipdService.getOperationSummaryByIpdId(this.ipdData.id)
      .pipe(
        takeUntil(this.destroy$),
        catchError(() => {
          this.operationSummary = null;
          return of({ result: null, isSuccess: false });
        })
      )
      .subscribe({
        next: (response) => {
          if (response?.result) {
            this.operationSummary = response.result;
          } else {
            this.operationSummary = null;
          }
        }
      });
  }

  canGenerateBill(ipd: Iipd): boolean {
    const hasDischargeDate = (ipd as any).dischargeDate !== null && (ipd as any).dischargeDate !== undefined;
    return hasDischargeDate;
  }

  openBillDialog(): void {
    const ipdId = this.ipdData?.id;
    if (!ipdId) {
      return;
    }

    if (!this.canGenerateBill(this.ipdData)) {
      this.toastr.warning(
        this.translate.instant('MESSAGE.BILL_ONLY_AFTER_DISCHARGE')
      );
      return;
    }

    this.ipdService.getIPDById(ipdId).subscribe({
      next: ({ result }) => {
        this.ipdDetails = result;

        const patientName = PatientNameUtils.formatFullName(this.patientinfo);

        const ipdBillData: IPDBillData = {
          ipdId: ipdId,
          opdId: this.ipdDetails.opdId,
          ipdNumber: String(
            this.ipdDetails.ipdNumber ?? this.ipdDetails.ipdno ?? ''
          ),
          patientId: this.patientinfo.id,
          patientName,

          admissionDate: new Date(this.ipdDetails.ipdDate),
          dischargeDate: this.ipdDetails.dischargeDate
            ? new Date(this.ipdDetails.dischargeDate)
            : new Date(),

          roomChargeId:
            this.ipdDetails.roomChargeId ??
            this.ipdDetails.roomType?.chargeId ??
            this.ipdDetails.roomType?.billCharge?.id ??
            0,

          roomCharge:
            this.ipdDetails.roomCharge ??
            (this.ipdDetails.roomType?.billCharge?.charge
              ? parseFloat(this.ipdDetails.roomType.billCharge.charge)
              : 0),

          roomTypeName: this.ipdDetails.roomTypeName ?? this.ipdDetails.roomType?.name ?? '',
          wardName: this.ipdDetails.wardName ?? ''
        };

        const dialogData: BillDialogData = {
          billType: BillType.IPDBill,
          ipdBillData: ipdBillData,
          selectedDoctorId: this.ipdDetails.doctorId
        };

        this.dialog.open(AddBillChargeComponent, {
          autoFocus: false,
          position: { top: '0', right: '0' },
          height: '100vh',
          width: '82vw',
          maxWidth: '1400px',
          panelClass: ['bill-dialog', 'side-panel'],
          data: dialogData
        });
      },

      error: () => {
        this.toastr.error(
          this.translate.instant('MESSAGE.ERROR_LOADING_IPD_DETAILS')
        );
      }
    });
  }
  openDischargeCard() {
    if (!this.ipdData || !this.ipdData.id) {
      return;
    }

    const dialogRef = this.dialog.open(IpdDischargeComponent, {
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        patientDetails: this.patientinfo,
        opdDetails: this.OpdData,
        ipdId: this.ipdData.id,
        ipdData: this.ipdData,
        readOnly: this.hasDischargeDate(),
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result) {
        // Reload IPD data after successful update
        this.loadIpdData();
      }
    });
  }

  hasDischargeDate(): boolean {
    return !!(this.ipdData?.dischargeDate && this.ipdData?.dischargeTime);
  }

  get dailyReportDisplayedColumns(): string[] {
    return ['reportDate', 'reportTime', 'summary', 'actions'];
  }

  openDayToDayDetails(){
    if (this.hasDischargeDate() && !this.dailyReports?.length) {
      return;
    }

     const dialogRef = this.dialog.open(DayToDayComponent, {
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        patientDetails: this.patientinfo,
        opdDetails: this.OpdData,
        patientId: this.patientinfo?.id,
        opdId: this.OpdData?.id ?? this.ipdData?.opdId,
        ipdId: this.ipdData?.id,
        ipdNumber: this.ipdData?.ipdNumber,
        ipdData: this.ipdData,
        doctorData: this.doctorDetails,
        doctorId: this.doctorDetails?.id ?? this.ipdData?.doctorId,
        isDialog: false,
        readOnly: this.hasDischargeDate()
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      if (result) {
        this.loadDailyReports();
      }
    });
  }

  private loadDailyReports(): void {
    if (!this.ipdData?.id || !this.patientinfo?.id) return;

    this.dailyReportService.list({
      patientId: this.patientinfo.id,
      opdId: this.OpdData?.id ?? this.ipdData.opdId ?? null,
      ipdId: this.ipdData.id
    })
      .pipe(takeUntil(this.destroy$), catchError(() => of({ result: [] } as any)))
      .subscribe(response => {
        this.dailyReports = response.result ?? [];
      });
  }

  getDailyReportSummary(report: IPatientDailyReport): string {
    return [
      report.dailynotes,
      report.plan
    ].find(value => !!value?.trim()) ?? this.translate.instant('LABEL.MEDICINE_ORDERS');
  }

  openDailyReportDetail(report: IPatientDailyReport): void {
    const isDischarged = this.hasDischargeDate();
    const dialogRef = this.dialog.open(PatientDailyReportComponent, {
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      disableClose: true,
      data: {
        patientDetails: this.patientinfo,
        opdDetails: this.OpdData,
        patientId: this.patientinfo?.id,
        opdId: this.OpdData?.id ?? this.ipdData?.opdId,
        ipdId: this.ipdData?.id,
        ipdNumber: this.ipdData?.ipdNumber,
        ipdData: this.ipdData,
        doctorData: this.doctorDetails,
        doctorId: this.doctorDetails?.id ?? this.ipdData?.doctorId,
        mode: isDischarged ? 'view' : 'edit',
        report,
        readOnly: isDischarged,
        isDialog: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result?.saved) {
        this.loadDailyReports();
      }
    });
  }

  openMedicalCertificate() {
    const dialogRef = this.dialog.open(MedicalCertificateComponent, {
      height: 'auto',
      minWidth: '45vw',
      minHeight: '50vh',
      disableClose: true,
      data: {
        patientDetails: this.patientinfo,
        opdDetails: this.OpdData,
        ipdData: this.ipdData,
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result) => {
      // if (result) {
      //   // Reload IPD data after successful update
      //   this.loadIpdData();
      // }
    });
  }

  viewOPD(row: Iopd): void {
    if (row.patientId && row.id) {
      this.router.navigate(['/opd', row.patientId, 'consultation', row.id]);
    }
  }

  viewPatientDetails(element: IPatientInfo): void {
    this.dialog.open(PatientViewComponent, {
      autoFocus: false,
      position: { top: '0', right: '0' },
      height: '100vh',
      width: '82vw',
      maxWidth: '1400px',
      panelClass: 'side-panel',
      data: {
        patient: element,
      }
    }).afterClosed().subscribe();
  }

  printDischarge() {
    this.reportPrintComponent?.printDischargeDetails();
  }

  printIPDAdmissionPaper() {
    this.printAdmissionPaperWithCurrentData();
  }

  openMedicalRecord() {
    if (this.hasDischargeDate() || !this.patientinfo?.id) {
      return;
    }

    this.dialog.open(MedicalRecordDetailComponent, {
      width: '100vw',
      maxWidth: '600px',
      disableClose: true,
      data: { 
        patientId: this.patientinfo.id,
        defaultType: MedicalReportType.IPD 
      }
    })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
         if (res && this.medicalRecordComponent) {
            this.medicalRecordComponent.loadMedicalRecords();
         }
      });
  }

  onMedicalRecordLength(count: number): void {
    this.medicalRecordCount = count;
  }

}
